import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { PromotionDto } from '../types/dtos';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.mutation<void, PromotionDto>({
        query: (payload) => ({
            url: APP_ENDPOINTS.PROMOTIONS,
            method: 'POST',
            body: payload,
        }),
        invalidatesTags: [{ type: 'promotions', id: 'GET' }],
    });
